import React from 'react';

import BaseTable, { BaseTableCellContextType } from 'components/common/baseTable/BaseTable';

interface TopVisitedPage {
  page: string;
  visits: number;
}

interface TopVisitedPagesProps {
  data: TopVisitedPage[];
}

const TopVisitedPages = ({ data }: TopVisitedPagesProps): React.ReactElement => {
  const columnDefinitions = [
    {
      accessorKey: 'page',
      header: 'Page',
      cell: ({ getValue }: BaseTableCellContextType) => (
        <span style={{ color: '#333', fontWeight: 'bold' }}>{getValue() as string}</span>
      ),
    },
    {
      accessorKey: 'visits',
      header: 'Visits',
      cell: ({ getValue }: BaseTableCellContextType) => (
        <span style={{ textAlign: 'right', color: '#333' }}>{getValue() as number}</span>
      ),
    },
  ];

  return (
    <BaseTable
      data={data}
      columnDefinitions={columnDefinitions}
      title='Top Visited Pages'
      initialPageSize={5}
      pageSizeOptions={[5, 10]}
    />
  );
};

export default TopVisitedPages;
